import { render } from "./sb-nav-bar.vue?vue&type=template&id=341b735a&ts=true"
import script from "./sb-nav-bar.ts?vue&type=script&lang=ts"
export * from "./sb-nav-bar.ts?vue&type=script&lang=ts"

import "./sb-nav-bar.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/luca/comperioprojects/selfbox_frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__